import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'styled-components';
import { ToasterSystem } from '@accesa/react-core/build/ui/toasterSystem';
import { Core } from '@accesa/react-core/build/core';
import { AppWrapper } from './containers/appWrapper';

const rootElement =
    document.getElementById('root') || document.createElement('div');

ReactDOM.render(
    <React.StrictMode>
        <ThemeProvider theme={{ mode: 'light' }}>
            <Core />
            <ToasterSystem>
                <AppWrapper />
            </ToasterSystem>
        </ThemeProvider>
    </React.StrictMode>,
    rootElement
);
